import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

export default function ServingSizeSelector({ baseServings, currentServings, onChange }) {
    const [servings, setServings] = useState(currentServings || baseServings);

    useEffect(() => {
        setServings(currentServings || baseServings);
    }, [currentServings, baseServings]);

    // Generate serving options from 1 to 20 (or adjust range as needed)
    const servingOptions = Array.from({ length: 20 }, (_, i) => i + 1);

    const handleChange = (value) => {
        const newServings = parseInt(value);
        setServings(newServings);
        onChange(newServings);
    };

    return (
        <div style={styles.container}>
            <Text style={styles.label}>Adjust Servings:</Text>
            <select
                value={servings}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                    width: '200px',
                    height: '40px',
                    fontSize: '16px',
                    padding: '8px',
                    marginVertical: '5px',
                    borderRadius: '4px',
                    borderColor: '#ddd',
                    borderWidth: '1px',
                    backgroundColor: '#fff',
                }}
            >
                {servingOptions.map((num) => (
                    <option key={num} value={num}>
                        {num} {num === 1 ? 'serving' : 'servings'}
                    </option>
                ))}
            </select>
            <Text style={styles.baseServings}>
                (Original recipe serves {baseServings})
            </Text>
        </div>
    );
}

const styles = StyleSheet.create({
    container: {
        marginVertical: 10,
        padding: 10,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        fontSize: 16,
        marginBottom: 5,
        fontWeight: '500',
    },
    baseServings: {
        fontSize: 14,
        color: '#666',
        fontStyle: 'italic',
        marginTop: 5,
    },
});
